<ng-container *ngIf="showUploadIcon">
  <button
    glxyComposerActionButton
    mat-icon-button
    (click)="hiddenUploader.browseForFiles()"
    matTooltip="{{ 'INBOX.UPLOAD_FILE.TITLE' | translate }}"
    [disabled]="isRecording"
  >
    <mat-icon [inline]="true">attach_file</mat-icon>
  </button>
</ng-container>
<ng-container *ngIf="enableVoiceRecording">
  <button
    matTooltip="{{
      isRecording
        ? ('INBOX.UPLOAD_FILE.VOICE_RECORDING.STOP_RECORDING' | translate)
        : ('INBOX.UPLOAD_FILE.VOICE_RECORDING.TITLE' | translate)
    }}"
    glxyComposerActionButton
    mat-icon-button
    (click)="toggleRecording()"
    [disabled]="disableVoiceRecording$ | async"
  >
    <mat-icon *ngIf="!isRecording; else recordingState" [ngClass]="{ recording: isRecording }" [inline]="true">
      keyboard_voice
    </mat-icon>
    <ng-template #recordingState>
      <mat-icon [inline]="true" class="recording">fiber_manual_record</mat-icon>
    </ng-template>
  </button>
</ng-container>

<glxy-uploader
  style="display: none"
  #hiddenUploader
  [maxFiles]="maxFiles"
  [maxFileSize]="selectedChatSourceId | maxFileSize"
  [accept]="selectedChatSourceId | acceptedFileType"
  [autoUpload]="true"
  [layout]="'button-only'"
  (fileUploaded)="fileUploaded($event)"
  (fileUploadErrored)="uploadErrored($event)"
  (filesChanged)="filesChanged($event)"
></glxy-uploader>
